export default __webpack_public_path__ + "static/media/design-illustration-2.2042c57b.svg";